import React from 'react';
import { IonInput } from '@ionic/react';
import { useForm } from 'react-hook-form';
import type { ProductModelSearchResult } from 'core/types';
import ProductModelSearchSelect from 'features/shared/inventory/components/ProductModelSearchSelect';

type RegisterFn = ReturnType<typeof useForm>['register'];

export interface ProductModelSerialStepFieldsProps {
  /** Class prefix shared by both fields, e.g. 'hk-digital-catalog-details'. */
  classPrefix: string;
  typeId: number | null | undefined;
  value: number | null | undefined;
  valueLabel: string | null | undefined;
  register: RegisterFn;
  onModelChange: (result: ProductModelSearchResult) => void;
}

/**
 * Model Number (catalog typeahead) + Serial Number (free text) fields, shared
 * by DigitalCatalogDetails.tsx's two question variants and
 * InventoryAddProduct.tsx's Add Item flow — all three previously carried
 * byte-identical copies of this pair. Serial Number has no catalog-tie-in
 * constraint (maps directly to Products.serial); Model Number always
 * resolves to a real product_template_id via the picked search result.
 */
const ProductModelSerialStepFields: React.FC<
  ProductModelSerialStepFieldsProps
> = ({ classPrefix, typeId, value, valueLabel, register, onModelChange }) => {
  return (
    <>
      <ProductModelSearchSelect
        className={`${classPrefix}-catalog-select`}
        variant="compact"
        placeholder="Type the Model Number (Optional)"
        typeId={typeId}
        value={value}
        valueLabel={valueLabel}
        onChange={onModelChange}
      />
      <IonInput
        name="serial"
        ref={register}
        className={`${classPrefix}-input ${classPrefix}-catalog-select`}
        placeholder="Type the Serial Number (Optional)"
      />
    </>
  );
};

export default ProductModelSerialStepFields;
